// i18n area 'tasks' — locale fr-FR (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.fr-FR.meta.json.
import type { enUS } from './tasks'

export const frFR: typeof enUS = {
  macrotasks: {
    title: 'Macrotasks',
    subtitle: "Opérations composées — reprenables depuis l'étape échouée, ou annulables",
    colType: 'Type',
    colTarget: 'Objet',
    colPhase: 'Phase',
    colSteps: 'Étapes',
    empty: 'Aucune macrotask',
    detail: 'Détails',
    failedAt: 'échouée à',
    resume: "Réessayer depuis l'étape échouée",
    abort: 'Tout annuler',
    cancel: 'Annuler',
    actionError: "L'action a été refusée"
  },
  tasks: {
    title: 'Tasks',
    searchPlaceholder: 'Rechercher par type ou target',
    type: 'Type',
    target: 'Target',
    phaseLabel: 'Phase',
    progress: 'Progression',
    started: 'Démarrée',
    finished: 'Terminée',
    node: 'Nœud',
    empty: 'Aucune task',
    loadError: 'Impossible de charger les tasks — le backend TVirt est-il joignable ?',
    limboHint: "Nœud '{node}' injoignable depuis {time} — la task retient le write lease sur son target jusqu'à ce que le nœud revienne ou soit attesté éteint",
    nodeAttested: 'Nœud attesté éteint',
    phase: {
      queued: "En file d'attente",
      running: 'En cours',
      succeeded: 'Réussie',
      failed: 'Échouée',
      cancelled: 'Annulée',
      'failed-at-step': 'Échouée à une étape',
      aborted: 'Interrompue'
    },
    dropdown: {
      tooltip: 'Tasks en cours',
      title: 'Tasks en cours',
      empty: 'Aucune task en cours',
      viewAll: 'Voir toutes les tasks'
    },
    detail: {
      open: 'Détails',
      scope: 'Périmètre',
      message: 'Message',
      params: 'Paramètres',
      result: 'Résultat',
      errorTitle: 'Erreur',
      steps: 'Étapes',
      failedAt: 'échouée à',
      superseded: 'dépassée',
      step: 'Étape',
      parent: 'Task parente',
      failedStep: 'Étape échouée',
      log: 'Log',
      logEmpty: 'Encore aucune ligne de log',
      close: 'Fermer'
    },
    actions: {
      cancel: 'Annuler',
      resume: "Réessayer depuis l'étape échouée",
      abort: 'Tout annuler (undo des étapes terminées)',
      refused: "L'action a été refusée"
    }
  },
  events: {
    loadError: 'Impossible de charger le journal — le backend TVirt est-il joignable ?',
    title: 'Événements',
    subtitle: 'La mémoire historique du cluster : faits accomplis, du plus récent',
    filterSeverity: 'Gravité',
    filterCategory: 'Catégorie',
    filterAll: 'Toutes',
    searchLabel: 'Rechercher',
    searchPlaceholder: 'Rechercher dans tout le journal',
    subjectFilter: 'Événements de {subject} — tout afficher',
    colAt: 'Quand',
    colSeverity: 'Gravité',
    colType: 'Type',
    colSubject: 'Sujet',
    colActor: 'Qui',
    colNode: 'Nœud',
    colMessage: 'Message',
    empty: 'Aucun événement',
    loadMore: 'Charger plus',
    actorSystem: 'système',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: "ID de l'événement",
    taskCollectedHint: 'Le task a une rétention plus courte : une fois collecté, le lien ne répond plus',
    severity: {
      info: 'Information',
      warning: 'Avertissement',
      error: 'Erreur',
      critical: 'Critique'
    },
    category: {
      lifecycle: 'Cycle de vie',
      config: 'Configuration',
      availability: 'Disponibilité',
      security: 'Sécurité'
    },
    type: {
      haNetsvcFailedOver: 'Failover du service réseau',
      haNetsvcNoCandidate: 'Service réseau sans nœud candidat',
      haNetsvcReaped: 'Instance locale fauchée à la réintégration',
      netsvcFloatipMoved: 'IP flottante déplacée vers un autre détenteur',
      netsvcFloatipNoHolder: 'IP flottante sans cible saine',
      haAppFailedOver: "Failover de l'instance App",
      haAppNoCandidate: 'Instance App sans nœud candidat',
      haAppStorageLocalSkip: 'Instance App non basculée : données persistantes locales au nœud mort',
      haAppReaped: "Pod local de l'instance App fauché au retour"
    }
  },
  audit: {
    loadError: "Impossible de charger le registre d'audit — le backend TVirt est-il joignable ?",
    title: 'Audit',
    subtitle: 'Qui a fait quoi, quand, sur quel objet — actes tentés, refus compris',
    filterOutcome: 'Issue',
    filterAll: 'Toutes',
    filterSudo: 'Actes élevés uniquement',
    colAt: 'Quand',
    colActor: 'Qui',
    colAction: 'Action',
    colTarget: 'Objet',
    colOutcome: 'Issue',
    colNode: 'Nœud',
    empty: 'Aucun acte enregistré',
    loadMore: 'Charger plus',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Route',
    detailProblem: 'Motif',
    detailTask: 'Task',
    detailClientIp: 'Depuis',
    detailId: "ID de l'enregistrement",
    detailSession: 'Session',
    taskHint: "L'issue d'un acte accepté vit dans le journal des événements, sous ce même id de task",
    outcome: {
      succeeded: 'Réussi',
      accepted: 'Accepté',
      denied: 'Refusé',
      rejected: 'Rejeté',
      failed: 'Échoué'
    }
  },
  notifications: {
    loadError: 'Impossible de charger les notifications — le backend TVirt est-il joignable ?',
    actionError: "L'action a été refusée",
    title: 'Notifications',
    subtitle: 'Les destinations vers lesquelles les faits du journal sortent du cluster',
    rulesTitle: 'Règles',
    rulesSubtitle: 'Quels faits sortent, et vers où',
    deliveriesTitle: 'Livraisons',
    deliveriesSubtitle: 'Le résultat de chaque notification, avec le pourquoi en cas d\'échec',
    colName: 'Nom',
    colKind: 'Type',
    colWhere: 'Où',
    colScope: 'Scope',
    colSeverity: 'Gravité',
    colMatch: 'Filtre',
    colTargets: 'Destination',
    colAt: 'Quand',
    colState: 'État',
    colEvent: 'Événement',
    colAttempts: 'Tentatives',
    colOutcome: 'Résultat',
    empty: 'Aucune ligne',
    matchAll: 'tous les faits',
    test: 'Tester',
    testOk: 'Notification de test livrée à {target}',
    testFailed: 'Test vers {target} échoué : {reason}',
    retry: 'Remettre en file',
    retried: 'Livraison remise en file',
    grouped: 'et {count} autres répétitions',
    state: {
      failed: 'Échouée',
      pending: 'En file',
      sending: "En cours d'envoi",
      sent: 'Envoyée'
    },
    tabTargets: 'Destinations',
    tabRules: 'Règles',
    tabDeliveries: 'Livraisons',
    targetCreateTitle: 'Nouvelle destination',
    ruleCreateTitle: 'Nouvelle règle',
    nameHint: 'Minuscules, chiffres et tirets ; unique par périmètre',
    kindImmutableHint: 'Immuable : changer le type revient à créer une autre destination',
    kindSmtp: 'Courrier (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'État',
    enabledOn: 'Active',
    enabledOff: 'Suspendue',
    smtpHost: 'Serveur SMTP',
    smtpPort: 'Port',
    smtpPortHint: 'Habituel : 25 sans TLS, 587 avec starttls, 465 avec tls',
    smtpSecurity: 'Sécurité',
    smtpFrom: 'Expéditeur',
    smtpTo: 'Destinataires',
    smtpToHint: 'Une ou plusieurs adresses séparées par des virgules',
    webhookUrl: 'URL',
    payload: 'Contenu',
    payloadHint: "Avec minimal, le message et les données de l'événement ne quittent pas le cluster",
    credential: 'Identifiant',
    credentialNone: 'Aucun',
    credentialHintSmtp: 'Le compte du relais depuis le keystore ; aucun signifie SMTP anonyme',
    credentialHintWebhook: "Le secret de signature depuis le keystore ; sans signature, quiconque connaît l'URL peut se faire passer pour le cluster",
    minSeverityHint: 'Un seuil, pas un ensemble : à partir de cette gravité',
    categories: 'Catégories',
    categoriesHint: 'Vide = toutes',
    types: "Types d'événement",
    typesHint: 'Séparés par des virgules ; vide = tous. Un type inconnu est refusé',
    targetsHint: 'Au moins une ; elles doivent vivre dans le périmètre de la règle ou un de ses ancêtres',
    recursiveOn: 'Aussi les périmètres enfants',
    recursiveOff: 'Ce périmètre seulement',
    recursiveHint: 'Les ressources vivent dans les feuilles : sans les enfants, une règle sur la racine ne notifie presque rien',
    repeatWindow: 'Fenêtre de regroupement (s)',
    repeatWindowHint: "Dans la fenêtre, les répétitions n'envoient rien : elles sont comptées sur la première. 0 désactive",
    targetInUseError: 'La destination {name} est encore utilisée par une règle'
  }
}
